








































import { Component, Prop, PropSync, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Col,
  DataTable,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { systemCodeApi, SystemCodeWithKey } from '@/api'
import { orderBy } from 'lodash'
import { InputCode } from '@/components/molecules/InputCode'
import { CODE_KEY } from '@/config'
import { SortOrder, UserDetailStateInfo } from '@/types'

const COLS: Col[] = [
  {
    width: 40,
    items: [
      {
        name: 'descNo',
        align: 'right'
      }
    ]
  },
  {
    width: '20',
    items: [
      {
        name: 'genre',
        headerText: 'ジャンル',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '80',
    items: [
      {
        name: 'opt1',
        headerText: '分類番号範囲',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: 30,
    items: [
      {
        name: 'remove',
        align: 'center'
      }
    ]
  }
]

export interface UserNewArrivalNoticeTableItem {
  id: number
  genre: {
    input: string
    display: string
    errorMessage: string
  }
  opt1: string
}

const defaultUserNewArrivalNoticeTableItem = (): UserNewArrivalNoticeTableItem => ({
  id: 0,
  genre: {
    input: '',
    display: '',
    errorMessage: ''
  },
  opt1: ''
})

@Component({
  components: {
    InputCode,
    DataTable
  }
})
export default class UserNewArrivalNoticeGenreTable extends ComponentVue {
  @PropSync('items', {
    type: Array,
    required: true
  })
  inputItems!: UserNewArrivalNoticeTableItem[]

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get sortedInputItems(): UserNewArrivalNoticeTableItem[] {
    if (this.sortName) {
      return orderBy<UserNewArrivalNoticeTableItem>(
        this.inputItems,
        (item: UserNewArrivalNoticeTableItem) => {
          switch (this.sortName) {
            case 'genre':
              return item.genre.display
            case 'opt1':
              return item.opt1
          }
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.inputItems
  }

  get contactsInfoTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.BY_GENRE.KEY)
  }

  get allCols(): Col[] {
    if (this.state.isCreateOrUpdate()) {
      return COLS.map(col => {
        return {
          width: col.width,
          items: col.items.map(item => {
            return {
              name: item.name,
              headerText: item.headerText,
              align: item.align,
              sortable: false,
              sortOrder: item.sortOrder,
              lineFeed: item.lineFeed
            }
          })
        }
      })
    }

    return COLS
  }

  get cols(): Col[] {
    if (this.state.isCreateOrUpdate()) {
      return this.allCols
    }
    return this.allCols.filter((item: Col) => {
      return item.items[0].name !== 'remove'
    })
  }

  @Watch('state.state')
  onChangeState(): void {
    this.onSort({
      name: '',
      order: ''
    })
  }

  add(): void {
    this.inputItems.unshift(defaultUserNewArrivalNoticeTableItem())
  }

  remove(index: number): void {
    this.inputItems.splice(index, 1)
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }
}
